enum ROUTES {
  MY_COURSE = "/my-course",
  MY_COURSES = "/my-courses",
  EXERCISES = "/exercises",
}

export const getExerciseUrl = (
  courseId: string | number,
  unitId: string | number,
  blockId: string | number,
  exerciseId: string | number
) =>
  `${ROUTES.MY_COURSES}/${courseId}${ROUTES.EXERCISES}/${unitId}?blockId=${blockId}&exerciseId=${exerciseId}`;

export const getUnitUrl = (
  courseId: string | number,
  unitId: string | number
) => `${ROUTES.MY_COURSES}/${courseId}${ROUTES.EXERCISES}/${unitId}`;

export const getCourseUrl = (courseId: string | number) =>
  `${ROUTES.MY_COURSES}/${courseId}`;
